<template>
  <div class="d-flex w-100">
    <b-form class="w-50" @submit.stop.prevent="">
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Personal Details</h5>
        <b-row>
          <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">First Name:</span> {{ user.firstName }}</b-col>
          <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Last Name:</span> {{ user.lastName }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Phone:</span> {{ user.phone }}</b-col>
          <b-col cols="12" xl="6" class="pb-2"><span class="text-muted">Email:</span> {{ user.email }}</b-col>
        </b-row>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Groups</h5>
        <UserAccountGroupForm :activeGroups="newGroups" :groups="groups.data" v-on:handleAdd="handleGroupAdd" v-on:handleRemove="handleGroupRemove"/>
      </div>
      <div>
        <b-button class="spnod-admin__form--button" @click="handleSave" size="sm">
          <p v-if="!isSending">Save</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
        <b-button class="bg-danger" @click="$emit('handleCancel')" size="sm">Cancel</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserAccountGroupForm from './UserAccountGroupForm'
import moment from 'moment'

export default {
  name: 'UserAccountForm',
  data() {
    return {
      form: {
        address: {
          address_line1: null,
          address_line2: null,
          city: null,
          state: null,
          zip: null
        }
      },
      avatar: {},
      newParents: [],
      newGroups: [],
      states: [],
      selectedNutritionist: null,
      selectedState: null,
      isSending: false
    }
  },
  props: ['user', 'isAdmin', 'forClient'],
  components: { UserAccountGroupForm },
  methods: {
    ...mapActions(['getStates', 'getNutritionists', 'getGroups']),
    handleRemove(index) {
      this.form.parents.splice(index, 1)
    },
    handleSave() {
      this.isSending = true
      this.$emit('handleSave', this.dataToSave)
    },
    handleGroupAdd(group) {
      const contains = this.newGroups.some(g => g._id === group._id)
      if (!contains) {
        this.newGroups.push(group)
      }
    },
    handleGroupRemove(group) {
      this.newGroups = this.newGroups.filter(g => g._id !== group._id)
    },
    addParent() {
      this.newParents.push({
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      })
    },
    changedAvatar() {
      let avatarData = this.avatar.generateDataUrl()
      if (avatarData !== '' && avatarData !== this.form.profilePic) {
        this.form.profilePic = this.avatar.generateDataUrl()
      }
    }
  },
  computed: {
    ...mapGetters(['dietitians', 'groups']),
    displayParents() {
      return this.form.parents && this.form.parents.length > 0
    },
    dataToSave() {
      const parents = this.newParents.filter(p => Object.values(p).every(x => x !== null && x !== ''))
      this.form.parents.push(...parents)
      this.form.newGroups = this.newGroups
      this.form.nutritionist = this.selectedNutritionist
      this.form.address.state = this.selectedState
      return this.form
    },
    displayNutritionist() {
      return this.forClient && this.isAdmin
    },
    street() {
      return (this.user.address) ? this.user.address.address_line1 : ''
    },
    street2() {
      return (this.user.address) ? this.user.address.address_line2 : ''
    },
    city() {
      return (this.user.address) ? this.user.address.city : ''
    },
    state() {
      return (this.user.address) ? this.user.address.state : ''
    },
    zipcode() {
      return (this.user.address) ? this.user.address.zip : ''
    },
    dob() {
      // Remove trailing Z from UTC & format date
      if (!this.user.DOB) return
      const utc = this.user.DOB
      const time = utc.substring(0, utc.length - 1)
      return moment(time).format('MM/DD/YYYY')
    }
  },
  mounted: async function () {
    const clone = this.user
    if (!clone.address) clone.address = this.form
    await this.getGroups({})
    this.form = clone
    this.newParents = []
    this.newGroups = clone.groups
    this.states = await this.getStates()
    if (clone.nutritionist) this.selectedNutritionist = clone.nutritionist._id
    if (clone.address.state) this.selectedState = clone.address.state
    await this.getNutritionists({})
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/UserAccount/UserAccountForm.vue?e67b7b74